import { Controller } from "@hotwired/stimulus"

// Контроллер для генерации и копирования пароля на форме пользователя
export default class extends Controller {
  static targets = ["passwordField", "generateBtn", "copyBtn", "copyFeedback"]

  generate() {
    const digits = Math.floor(1000000000 + Math.random() * 9000000000).toString()
    this.passwordFieldTarget.value = digits
    this.passwordFieldTarget.type = "text"
    this.showCopyFeedback("Пароль сгенерирован")
  }

  copy() {
    const password = this.passwordFieldTarget.value
    if (!password) {
      this.showCopyFeedback("Поле пароля пустое", true)
      return
    }

    navigator.clipboard.writeText(password).then(() => {
      this.showCopyFeedback("Скопировано!")
    }).catch(() => {
      // Fallback для старых браузеров
      this.passwordFieldTarget.select()
      document.execCommand("copy")
      this.showCopyFeedback("Скопировано!")
    })
  }

  showCopyFeedback(message, isError = false) {
    if (!this.hasCopyFeedbackTarget) return

    const el = this.copyFeedbackTarget
    el.textContent = message
    el.classList.toggle("text-danger", isError)
    el.classList.toggle("text-success", !isError)
    el.classList.remove("d-none")

    clearTimeout(this._feedbackTimeout)
    this._feedbackTimeout = setTimeout(() => {
      el.classList.add("d-none")
    }, 2000)
  }
}
